import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { ProjectContext, type ProjectContextValue } from '@core/context';
import { useProjectStore } from '@core/store';

/**
 * Renders the custom HTML footer if available and the user has access.
 * The custom HTML footer can be defined at both the project and parent project levels.
 * If both are defined, they are concatenated and rendered together.
 */
export default function CustomHtmlFooter() {
  const { search } = useLocation();
  const planFeatures = useProjectStore(s => s.plan.features);

  // We have to pull the footer html from the ProjectContext because it includes appearance
  // settings inherited from the parent project. Project store data populated by apiv2 does
  // not inherit appearance from parent projects.
  const { project } = useContext(ProjectContext) as ProjectContextValue;
  const htmlFooter = project?.appearance?.html_footer;

  const query = new URLSearchParams(search);
  const disableCustom = query.get('disableCustom') === 'true';
  const hasAccess = planFeatures.whitelabel;

  return hasAccess && htmlFooter && !disableCustom ? <footer dangerouslySetInnerHTML={{ __html: htmlFooter }} /> : null;
}
